export default {
  methods: {
    copyToClipboard(textToCopy) {
      let textarea = document.createElement("textarea");
        textarea.textContent = textToCopy;
        textarea.style.position = "fixed";
        textarea.style.height = "0px";

        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
    }
  }
}
